import TagsCell from "@via/components/tags-cell.tsx";
import ProcessRunAction from "@via/pages/pipelines/processes/process-run-action.tsx";
import type { ProcessCatalogItem } from "common";
import type { JSX } from "react";

interface ProcessCardGridProps {
  items: ProcessCatalogItem[];
  isGuest: boolean;
  onRun: (item: ProcessCatalogItem) => void;
  onOpen: (item: ProcessCatalogItem) => void;
}

export default function ProcessCardGrid({
  items,
  isGuest,
  onRun,
  onOpen,
}: ProcessCardGridProps): JSX.Element {
  return (
    <ul
      role="list"
      className="grid grid-cols-1 gap-6 py-6 sm:grid-cols-2 lg:grid-cols-3">
      {items.map(item => (
        <li
          key={item.id}
          data-testid={`process-card-${item.id}`}
          title={item.summary}
          onClick={() => (item.canRun && !isGuest ? onRun(item) : onOpen(item))}
          className="duration-175 flex min-h-52 cursor-pointer flex-col justify-between divide-y divide-gray-200 rounded-lg bg-white text-left drop-shadow-md transition hover:drop-shadow-lg">
          <div className="p-4">
            <h3 className="text-md font-semibold text-gray-900">{item.name}</h3>
            <p className="mt-1 line-clamp-3 text-sm text-gray-500">
              {item.summary}
            </p>
            <p className="mt-2 text-xs text-gray-500">
              {item.ownerName}
              {item.menuGroupName ? ` · ${item.menuGroupName}` : ""}
            </p>
          </div>
          <div className="flex items-center justify-between gap-2 p-3">
            <TagsCell tags={item.tags} rowId={item.id} variant="card" />
            <div className="ml-auto flex items-center gap-2">
              <button
                type="button"
                onClick={event => {
                  event.stopPropagation();
                  onOpen(item);
                }}
                className="text-sm font-medium text-indigo-600 hover:text-indigo-500">
                {item.canRun && !isGuest ? "Open" : "View"}
              </button>
              <ProcessRunAction item={item} isGuest={isGuest} onRun={onRun} />
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}
